export const FREQUENCY_TREND_LIMIT_CONFIGURATION_PATH = "FrequencyTrendLimitConfiguration";
export const FREQUENCY_TREND_LIMIT_LOG_PATH = `${FREQUENCY_TREND_LIMIT_CONFIGURATION_PATH}/Log`;
export const FREQUENCY_TREND_CONFIGURED_LIMITS_PATH = `${FREQUENCY_TREND_LIMIT_CONFIGURATION_PATH}/ConfiguredLimits`;
export const FREQUENCY_TREND_LIMIT_CONFIGURATOR_PATH = `${FREQUENCY_TREND_LIMIT_CONFIGURATION_PATH}/LimitConfigurator`;
